export default "__VITE_ASSET__cb30bbde__"